import React from "react";
import PropTypes from "prop-types";
import { Table } from "@devexpress/dx-react-grid-material-ui";

import ConfTableBaseCellValue from "./ConfTableBaseCellValue";
import { parse } from "query-string";

const ConfTableNonEditableCell = (props) => {
  const { value, column, row } = props;

  const { isBalancingPosition } = column;

  let color = "#000000";

  if (isBalancingPosition) {
    const { walletProfile } = column;
    if (walletProfile === "conservative") {
      const currentPosition = parseFloat(value);
      const maxConsAllocation = parseFloat(row.maxConsAllocation) || 0;
      const minConsAllocation = parseFloat(row.minConsAllocation) || 0;

      if (currentPosition < minConsAllocation) {
        color = "#FF0000"; // Red if below minimum
      } else if (currentPosition > maxConsAllocation) {
        color = "#FF0000"; // Red if above maximum
      } else {
        color = "#008000"; // Green if within range
      }
    } else if (walletProfile === "mod_conservative") {
      const currentPosition = parseFloat(value);
      const maxConsModAllocation = parseFloat(row.maxConsModAllocation) || 0;
      const minConsModAllocation = parseFloat(row.minConsModAllocation) || 0;

      if (currentPosition < minConsModAllocation) {
        color = "#FF0000"; // Red if below minimum
      } else if (currentPosition > maxConsModAllocation) {
        color = "#FF0000"; // Red if above maximum
      } else {
        color = "#008000"; // Green if within range
      }
    } else if (walletProfile === "moderate") {
      const currentPosition = parseFloat(value);
      const maxModAllocation = parseFloat(row.maxModAllocation) || 0;
      const minModAllocation = parseFloat(row.minModAllocation) || 0;

      if (currentPosition < minModAllocation) {
        color = "#FF0000"; // Red if below minimum
      } else if (currentPosition > maxModAllocation) {
        color = "#FF0000"; // Red if above maximum
      } else {
        color = "#008000"; // Green if within range
      }
    } else if (walletProfile === "mod_aggressive") {
      const currentPosition = parseFloat(value);
      const maxModAggrAllocation = parseFloat(row.maxModAggrAllocation) || 0;
      const minModAggrAllocation = parseFloat(row.minModAggrAllocation) || 0;

      if (currentPosition < minModAggrAllocation) {
        color = "#FF0000"; // Red if below minimum
      } else if (currentPosition > maxModAggrAllocation) {
        color = "#FF0000"; // Red if above maximum
      } else {
        color = "#008000"; // Green if within range
      }
    } else if (walletProfile === "aggressive") {
      const currentPosition = parseFloat(value);
      const maxAggrAllocation = parseFloat(row.maxAggrAllocation) || 0;
      const minAggrAllocation = parseFloat(row.minAggrAllocation) || 0;

      if (currentPosition < minAggrAllocation) {
        color = "#FF0000"; // Red if below minimum
      } else if (currentPosition > maxAggrAllocation) {
        color = "#FF0000"; // Red if above maximum
      } else {
        color = "#008000"; // Green if within range
      }
    }
  }

  return (
    <Table.Cell {...props}>
      <div style={{ minHeight: 20, color }}>
        <ConfTableBaseCellValue value={value} column={column} />
      </div>
    </Table.Cell>
  );
};

ConfTableNonEditableCell.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any.isRequired,
};

ConfTableNonEditableCell.defaultProps = {
  value: "",
};

export default ConfTableNonEditableCell;
